import React from "react";
import { Icon } from "antd";

import styles from "./backButton.scss";

const BackButton = ({ onClick }) => (
  <button type="button" className={styles.button} onClick={() => onClick()}>
    <Icon type="arrow-left" className={styles.icon} />
  </button>
);

export default BackButton;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/StepHeader/BackButton/index.tsx